<template>
    <Layout
        :header="{ text: '保單借款', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="1"></Process>
        </div>
        <div class="pb-8">
            <h2 class="font-bold text-2xl pb-4">選擇保單幣別</h2>
            <SelectBoxV2 :selectOptions="currencySelectOptions" />
        </div>
        <div class="pb-8">
            <h2 class="font-bold text-2xl pb-4">選擇匯款帳號</h2>
            <OptionBoxList :options="bankOptions" />
        </div>
        <div class="pb-8">
            <h2 class="font-bold text-2xl pb-4">選擇保單</h2>
            <div class="pb-4">
                <div class="p-5 flex rounded-md bg-[#F4FBFF]">
                    <div class="pt-1 pr-3">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM10 4.57153C10 4.01925 9.55229 3.57153 9 3.57153C8.44771 3.57153 8 4.01925 8 4.57153V4.58296C8 5.13525 8.44771 5.58296 9 5.58296C9.55229 5.58296 10 5.13525 10 4.58296V4.57153ZM10 8.0001C10 7.44782 9.55229 7.0001 9 7.0001C8.44771 7.0001 8 7.44782 8 8.0001V13.4287C8 13.981 8.44771 14.4287 9 14.4287C9.55229 14.4287 10 13.981 10 13.4287V8.0001Z"
                                fill="#0093C1" />
                        </svg>
                    </div>
                    <div>
                        要保人、被保險人不同之保單，需由專人與要保人、被保險人同時進行視訊確認；因視訊確認最多僅能3人同時進行，故只能選擇2位不同被保險人之保單。
                    </div>
                </div>
            </div>
            <OptionBoxList :options="policyOptions" />
        </div>
        <ul class="list-disc pl-6 text-sm">
            <li class="pb-2">單張保險契約單次借款之金額，最低限制為約當新臺幣1,000元。</li>
            <li class="pb-2">辦理保單借款時，若該保單尚有未清償之借款本息者，本次欲借款金額加已借款本息合計須於該保單最高可借款金額範圍內。</li>
            <li class="pb-2">保單已為繳清件、展期件、自動墊繳件、以支票還款且尚未兌現者，請洽本公司各地服務櫃檯，或由您的保單服務人員協助以書面方式辦理。</li>
            <li class="pb-2">保單因變更中、保單借/還款中或理賠申請中，暫時無法申請保單借款時，請通知您的服務人員協助辦理，或洽詢保單借還款服務專線0809-026-688。</li>
            <li class="pb-2">
                本公司不定期推出保單借款優惠專案，若您辦理保單借款當時符合專案條件，即可享有優惠，保單借款優惠專案詳情請查詢本公司官方網站www.fubon.com，或保單借還款服務專線0809-026-688。</li>
            <li class="pb-2">您的保險單、存摺、印章、網路交易帳號密碼應親自保管，請勿交予他人，本公司嚴禁業務同仁代保管客戶保險單、存摺、印章、網路交易帳號密碼等資料。</li>
        </ul>
        <div class="h-[200px]"></div>
        <template #fixedBottom>
            <div class="bg-white">
                <div class="max-w-[768px] mx-auto px-5 py-3">
                    <div>
                        選擇 <span class="text-[#00A59B]">{{ policyOptions.inputValue.length || '--' }}</span> 張保單
                    </div>
                    <div class="flex justify-between">
                        <div class="">總借款金額 ({{ currencySelectOptions.selectValue }})</div>
                        <div class="">{{ moneyTotal || '--' }}</div>
                    </div>
                    <div class="text-[#EB4751] text-sm">
                        <div v-show="true">最多只能選擇 2 位不同的被保險人</div>
                        <!-- <div v-show="true">單筆借款金額上限為新臺幣 100 萬元</div> -->
                    </div>
                </div>
            </div>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="!isAllowNext" @click="goNextPage">下一步</button>
        </template>
        <InfoBoxBottom boxTitle="經濟弱勢保戶保單借款優惠利率方案" :closeHandle="() => { specificInfoBoxVisible = false }"
            v-show="specificInfoBoxVisible">
            <div class="pb-6">
                <div class="py-5 flex justify-center items-center text-center rounded-md bg-[#EEF0F0]">
                    <div class="px-5 flex-1 border-r border-[#DADADA]">
                        <div class="pb-2 text-xs text-[#494A57]">最高申請額度</div>
                        <div class="font-bold">新臺幣 <span class="px-1 text-[#00A59B]">10</span> 萬元</div>
                    </div>
                    <div class="px-5 flex-1">
                        <div class="pb-2 text-xs text-[#494A57]">申請期間</div>
                        <div class="font-bold">113/1/1 ~ 3/31</div>
                    </div>
                </div>
            </div>
            <h5 class="font-bold pb-2">符合下列任一條件並具相關證明文件者，皆可申請：</h5>
            <ol class="list-decimal pl-6">
                <li class="pb-2">申請期間：114年1月1日至114年3月31日。</li>
                <li class="pb-2">申請資格：需符合下列任一條件並出具相關證明</li>
                <li class="pb-2">身心障礙者。</li>
                <li class="pb-2">低收入戶或中低收入戶。</li>
                <li class="pb-2">屬於特殊境遇家庭扶助條例所定特殊境遇家庭之成員。</li>
                <li class="pb-2">經濟困難者，說明如下：</li>
                <li class="pb-2">有雇主類型：因失業、無薪假、非自願離職、雇主實施減班休息、協商減薪、雇主營收衰退而減少獎金等實質收入減少導致經濟困難者。</li>
                <li class="pb-2">無雇主類型：客戶表達自己無雇主(包括但不限於攤商、自營商、自由工作者等)，但因營業收入下降或暫停營業導致經濟困難者。</li>
                <li class="pb-2">適用保單：依各保單條款約定，累積達有保單價值準備金或保單帳戶價值且可辦理保單借款之台幣保單均適用。(外幣保單不適用)</li>
                <li class="pb-2">優惠額度：申請日起同一要保人累計最高借款金額新台幣10萬元。(申請時如為曾辦理紓困借款者，申請人需清償之前已申辦之紓困借款專案餘額)</li>
                <li class="pb-2">
                    借款利率及優惠期間：經公司核定後，自借款日起保單借款利率為2.04%(依勞動部勞工保險局113年12月xx日公告114年勞工保險被保險人紓困貸款利率)，優惠期間三年，優惠期間過後，將依原訂的保單借款利率計算。
                </li>
                <li class="pb-2">於優惠利率期間仍須按時繳息，逾期欠繳之利息，遲付逾一年後經催告而不償還時，公司得將逾期欠繳之利息併入優惠利率借款本金中，並續以優惠利率複利計算利息。</li>
                <li class="pb-2">
                    優惠利率期間內，如有保險契約給付(如:生存/理賠金等)或契約變更等代償保單借款，其償還順序為1.利息2.一般利率借款3.優利借款；若致優惠利率借款本金受清償時，則清償後之優惠利率借款本金餘額依優惠利率計息至優惠期間屆滿；如代償保單借款致優惠利率借款本金全數清償時，則本專案自動終止。※如需申請本優惠利率方案，請先準備相關證明文件以利上傳。
                </li>
            </ol>
            <template #fixedBotton>
                <div class="footer-shadow">
                    <div class="flex w-full px-2 py-3 max-w-[768px] mx-auto">
                        <div class="flex-1 px-2">
                            <div class="cursor-pointer block py-3 text-center rounded bg-[#CCF3FF] text-[#0093C1]"
                                @click="directSubmit">
                                不申請
                            </div>
                        </div>
                        <div class="flex-1 px-2">
                            <RouterLink class="block py-3 text-center rounded bg-[#0093C1] text-white"
                                :to="{ name: '' }">
                                符合資格並申請
                            </RouterLink>
                        </div>
                    </div>
                </div>
            </template>
        </InfoBoxBottom>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>
<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, computed, watch, reactive } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import SelectBoxV2 from '@/components/cloudCounter/SelectBox.v2.vue';
import OptionBoxList from '@/components/cloudCounter/OptionBoxList.vue';
import InfoBoxBottom from '@/components/cloudCounter/InfoBoxBottom.vue';
import { getLoanPolicyInfo, postLoanSubmit } from '@/apis/CloudECounter';
import Loading from '@/components/Loading.vue';
import { currencyData } from './currencyData';
import routeName from '@/router/constant';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { openPopupCatchMessage, openPopup } from '@/utils/vfmUtils';

const router = useRouter();
const route = useRoute();
const store = useStore();
const code = route?.meta.code;

const moneyTotal = ref('');
const specificInfoBoxVisible = ref(false);
const isSpecificPeriod = ref(false);
const isLoading = ref(false);
let insuredPerson = new Set();
let originBankList = [];
let originPolicyList = [];

//選擇幣別
const currencySelectOptions = reactive({
    selectValue: '',
    placeholder: '',
    boxData: {
        boxTitle: '選擇保單幣別',
        options: []
    },
    setValue: (val) => {
        bankOptions.inputValue = '';
        policyOptions.inputValue = [];
        insuredPerson.clear();
        if (val === '新台幣') {
            bankOptions.inputOptions = originBankList.filter(el => el.currencyText === '新台幣');
        } else {
            bankOptions.inputOptions = originBankList.filter(el => el.currencyText === val || el.currency === 'ALL');
        }
        policyOptions.inputOptions = originPolicyList.filter(el => el.currencyText === val);
    }
});

//選擇銀行帳戶
const bankOptions = reactive({
    inputValue: '',
    inputName: 'bank',
    inputType: 'radio',
    inputOptions: [],
});

//選擇保單
const policyOptions = reactive({
    inputValue: [],
    inputType: 'checkbox',
    inputName: 'policy',
    inputOptions: [],
});

const isAllowNext = computed(() => {
    return currencySelectOptions.selectValue !== '' && bankOptions.inputValue !== '' && policyOptions.inputValue.length > 0 && checkInputMoney(policyOptions)
})

const checkValidNumber = (number) => {
    const regex = /^[0-9]*(\.[0-9]{1,2})?$/;
    return !regex.test(number);
}

// 找出目前有選取的保單，並確認是否為0或大於最大、小於最小、輸入為合法數字
const checkInputMoney = (opt) => {
    return !opt.inputOptions.filter(el => opt.inputValue.includes(el.optionValue)).some(el => Number(el.textInputList[0]?.value) === 0 || el.textInputList[0]?.value > el.textInputList[0]?.max || el.textInputList[0]?.value < el.textInputList[0]?.min || isNaN(el.textInputList[0]?.value) || checkValidNumber(el.textInputList[0]?.value))
}

const thousandthsFormat = (value) => {
    const regex = /\B(?=(\d{3})+(?!\d))/g
    if (Number.isInteger(value)) {
        return value.toString().replace(regex, ',');
    } else {
        return value.toFixed(2).replace(regex, ',');
    }
}

const getPolicyInfo = async () => {
    isLoading.value = true;
    const res = await getLoanPolicyInfo();

    if (res.data?.msgList?.[0]) {
        openPopup(res.data?.msgList?.[0], () => {
            router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
        })
    }

    // 改抓幣別的第一筆資料
    currencySelectOptions.boxData.options = currencyData.filter(element => res.data?.currencyList?.find(d2 => d2.currencyText === element.value));
    //currencySelectOptions.selectValue = '新台幣'

    currencySelectOptions.selectValue = res.data?.currencyList[0]?.currencyText

    originBankList = res.data?.bankList.map((val, index, arr) => {
        return {
            title: `${val.bankNo.substring(0, 3)} ${val.bankName}`,
            bottomSubTitle: `${val.currencyText}帳戶 ${val.bankAccount}`,
            optionValue: val.bankAccount,
            currencyText: val.currencyText,
            currency: val.currency,
            bankNo: val.bankNo,
        }
    });

    originPolicyList = res.data?.policyList.filter(val => val.loaned === true).map((val, index, arr) => {
        return {
            title: `${val.item} ${val.itemName}`,
            subTitle: val.fullPolicyNo,
            list: [
                { key: '被保險人', value: val.insdName, },
                { key: '本月利率 (年利率)', value: `${val.loanRate}%`, },
                { key: '可借款金額', value: `$${thousandthsFormat(val.lastLoanLimit)}`, },
                { key: '契約狀態', value: val.cnctStat, },
                { key: '已借款本金', value: `$${thousandthsFormat(val.lastLoanPrin)}`, },
                { key: '借款利息', value: `$${thousandthsFormat(val.lastLoanInter)}`, },
            ],
            optionValue: val.fullPolicyNo,
            textInputList: [{
                name: '欲借款金額',
                value: '',
                placeholder: '請輸入借款金額',
                type: 'text',
                max: val.lastLoanLimit,
                min: val.minAmount,
                minErrorText: `最低借款金額為 ${val.currencyText} ${thousandthsFormat(val.minAmount)}元`,
                maxErrorText: `可借款金額上限為 ${val.currencyText} ${val.lastLoanLimit}元`,
                inputmode: 'numeric'
            }],
            currencyText: val.currencyText,
            currency: val.currency,
            idDup: val.idDup,
            policyNo: val.policyNo,
            policySeq: val.policySeq,
            insdId: val.insdId,
        }
    });

    // 預設為NTD，故保單、銀行帳戶皆篩選為新台幣的資料
    // bankOptions.inputOptions = originBankList.filter(el => el.currency === 'NTD');
    // policyOptions.inputOptions = originPolicyList.filter(el => el.currency === 'NTD');

    // 預設抓幣別列表第一筆的幣別，做保單及銀行帳戶的資料篩選，若幣別為新台幣，僅顯示新台幣帳戶
    if (res.data?.currencyList[0]?.currency === 'NTD') {
        bankOptions.inputOptions = originBankList.filter(el => el.currency === "NTD");
    } else {
        bankOptions.inputOptions = originBankList.filter(el => el.currency === res.data?.currencyList[0]?.currency || el.currency === "ALL");
    }
    policyOptions.inputOptions = originPolicyList.filter(el => el.currency === res.data?.currencyList[0]?.currency);
    isLoading.value = false;
}

const result = computed(() => {
    return store.state.services.changeItemsResult[code];
});

const initData = async () => {
    if (result.value) {
        originBankList = result.value.originBankList;
        originPolicyList = result.value.originPolicyList;
        insuredPerson = result.value.insuredPerson || new Set();
        Object.assign(currencySelectOptions, { ...result.value.currencySelectOptions });
        Object.assign(bankOptions, { ...result.value.bankOptions });
        Object.assign(policyOptions, { ...result.value.policyOptions });
        moneyTotal.value = result?.value.moneyTotal;
    } else {
        getPolicyInfo();
    }

    // 將值回填後清空，避免有殘留資料
    store.dispatch('services/setChangeItemsResult', {
        code: code,
        value: null,
    });
}
initData();

const directSubmit = async () => {
    await submit();
}

const goNextPage = async () => {
    // 現行是否有經濟弱勢借款方案
    if (isSpecificPeriod.value) {
        specificInfoBoxVisible.value = true;
    } else {
        await submit();
    }
}

const submit = async () => {

    const selectedBank = bankOptions.inputOptions.find(bank => bank.optionValue === bankOptions.inputValue);
    const selectedPolicy = policyOptions.inputOptions.filter(el => policyOptions.inputValue.includes(el.optionValue)).map(el => {
        return {
            policyNo: el.policyNo,
            policySeq: el.policySeq,
            idDup: el.idDup || '',
            amount: el.textInputList[0]?.value,
        }
    })
    const data = {
        bankNo: selectedBank.bankNo,
        bankAccount: bankOptions.inputValue,
        pon4300List: selectedPolicy,
    }

    isLoading.value = true;
    try {
        const res = await postLoanSubmit(data)
        store.dispatch('services/setChangeItemsResult', {
            code: code,
            value: {
                originBankList,
                originPolicyList,
                currencySelectOptions,
                bankOptions,
                policyOptions,
                moneyTotal: moneyTotal.value,
                insuredPerson,
            },
        });
        router.push({ name: routeName.CLOUD_E_COUNTER_LOAN_CHECK });
    } catch (ex) {
        openPopupCatchMessage(ex);
    } finally {
        isLoading.value = false;
    }
}

watch(() => policyOptions, (_val) => {
    let sum = 0;
    const _inputOptions = policyOptions.inputOptions;
    insuredPerson.clear();
    if (_inputOptions.length >= 1) {
        if (_inputOptions.length == 1) {
            sum = parseInt(_inputOptions[0].textInputList[0].value) || 0;
        } else {
            for (let i = 0; i < _inputOptions.length; i++) {
                const element = _inputOptions[i];
                // console.log((policyOptions.value).inputValue);
                if (policyOptions.inputValue.includes(element.optionValue)) {
                    sum += (parseInt(element.textInputList[0].value) || 0);
                    insuredPerson.add(element.insdId);
                }
            }
        }
    }
    moneyTotal.value = thousandthsFormat(sum);
}, { deep: true });

watch(() => policyOptions.inputValue, (newVal, oldVal) => {
    // 最多只能兩位不同被保險人
    if (insuredPerson.size > 2) {
        openPopup('最多只能選擇 2 位不同的被保險人');
        policyOptions.inputValue = oldVal;
    }
})

// 是否需要視訊驗證

</script>
<style scoped></style>
